import utils from '@/helpers/utils'

export default function (_this) {
  return {
    async create (name, callback) {
      let uid = _this.getUserId()
      let dashKey = null

      await new Promise((resolve) => {
        let dashboard = {
          name: name,
          owner: uid
        }
        let key = _this.dashRef.push(dashboard, () => {
          dashKey = key
          resolve()
        }).key
      })

      await this.setInitialData(dashKey)

      _this.accessRef
        .child('Dashboard')
        .child(uid + '/' + dashKey).set({
          update: true
        })

      _this.tabs.create(dashKey)

      this.setEmailTemplatesPlaceholder(dashKey)

      callback()
    },
    setInitialData (dashKey) {
      return new Promise((resolve) => {
        _this.initialDataRef.once('value', (snapshot) => {
          let data = snapshot.val()

          if (data) {
            _this.dashRef.child(dashKey).update(data, () => {
              resolve()
            })
          } else {
            resolve()
          }
        })
      })
    },
    setEmailTemplatesPlaceholder (dashKey) {
      _this.root.ref(`emailTemplates/newUserInvite/${dashKey}`)
        .set({
          body: "email body placeholder",
          from: "email_from@placeholder.com",
          subject: "email subject placeholder"
        })
    },
    removeEmailTemplates (dashKey) {
      _this.root.ref(`emailTemplates/newUserInvite/${dashKey}`).remove()
    },
    delete (dashKey, callback) {
      let uid = _this.getUserId()
      let sharedWith = null
      let dashOwner = null

      new Promise((resolve) => {
        _this.dashRef.child(dashKey).once('value', (snapshot) => {
          let data = snapshot.val()
          dashOwner = data.owner
          if (data && data.sharedWith) sharedWith = data.sharedWith
          resolve()
        })
      }).then(() => {
        if (dashOwner === uid) {
          return new Promise((resolve) => {
            _this.dashRef.child(dashKey).remove(() => {
              resolve()
            })
          })
        } else {
          return new Promise((resolve) => {
            _this.dashRef.child(dashKey + '/sharedWith/' + uid).remove(() => {
              resolve()
            })
          })
        }
      }).then(() => {
        if (dashOwner === uid) {
          if (sharedWith) {
            for (let sharedUid in sharedWith) {
              _this.accessRef
                .child('Dashboard')
                .child(sharedUid + '/' + dashKey).remove()
            }
          }
          _this.accessRef
            .child('Dashboard')
            .child(uid + '/' + dashKey).remove(() => {
              if (callback) callback()
            })
        } else {
          _this.accessRef
            .child('Dashboard')
            .child(uid + '/' + dashKey).remove(() => {
              if (callback) callback()
            })
        }
      })

      this.removeEmailTemplates(dashKey)
    },
    edit (key, name) {
      _this.dashRef.child(key + '/name').set(name)
    },
    share (data, callback) {
      let uid = data.uid
      let dash = data.dash

      let promise = new Promise((resolve) => {
        _this.dashRef.child(dash + '/sharedWith/' + uid).set(true, () => {
          resolve()
        })
      })

      promise.then(() => {
        _this.accessRef
          .child('Dashboard')
          .child(uid + '/' + dash).update(data.rules, (err) => {
            if (err) callback(err)
            else callback()
          })
      })
    },
    makePublic (dash, setPublic, callback) {
      if (setPublic) {
        _this.root.ref('publicDashboards/' + dash).set(true, () => {
          callback()
        })
      } else {
        _this.root.ref('publicDashboards/' + dash).remove(() => {
          callback()
        })
      }
    },
    isPublic (dash, callback) {
      _this.root.ref('publicDashboards/' + dash).once('value', (snapshot) => {
        callback(snapshot.val())
      })
    },
    read (callback) {
      let uid = _this.getUserId()

      new Promise((resolve) => {
        _this.accessRef
          .child('Dashboard')
          .child(uid).once('value', (snapshot) => {
            if (snapshot.val()) resolve(snapshot.val())
            else resolve()
          })
      }).then((granted) => {
        let dashboards = {}
        for (let item in granted) {
          _this.dashRef.child(item).once('value', (snapshot) => {
            dashboards[item] = snapshot.val()
            if (utils.count(dashboards) === utils.count(granted)) callback(dashboards)
          })
        }
        if (!granted) callback(null)
      })
    },
    readOne (key, callback) {
      _this.root.ref('dashboards/' + key).on('value', (snapshot) => {
        callback(snapshot.val())
      })
    },
    clearAnonymousData (uid, callback) {
      let promise = new Promise((resolve) => {
        _this.accessRef
          .child('Dashboard')
          .child(uid).once('value', (snapshot) => {
            resolve(snapshot.val())
          })
      })

      promise.then((dashKeys) => {
        if (!dashKeys) callback()
        for (let key in dashKeys) {
          this.delete(key)
        }
        _this.accessRef
          .child('Dashboard')
          .child(uid).remove()
        callback()
      })
    },
    replaceOwner (oldUid, newUid, callback) {
      let promise = new Promise((resolve) => {
        _this.accessRef
          .child('Dashboard')
          .child(oldUid).once('value', (snapshot) => {
            if (!snapshot.val()) resolve()
            else resolve(snapshot.val())
          })
      })

      promise.then((dashKeys) => {
        if (!dashKeys) {
          callback()
        } else {
          _this.accessRef
            .child('Dashboard')
            .child(oldUid).remove()
          _this.accessRef
            .child('Dashboard')
            .child(newUid).set(dashKeys, () => {
              callback()
            })
        }
      })

      promise.then((dashKeys) => {
        if (!dashKeys) return

        for (let key in dashKeys) {
          _this.dashRef.child(key + '/owner').set(newUid)
        }
      })
    },
    /**
     * Read all dashboards
     */
    async readAll () {
      const dList = await new Promise((resolve) => {
        _this.root.ref('dashboardsList').once('value', (snapshot) => {
          resolve(snapshot.val())
        }, (err) => {
          console.error(err)
          resolve(null)
        })
      })
      const dAll = {}

      for (let dId in dList) {
        await new Promise ((resolve) => {
          _this.root.ref(`dashboards/${dId}`).once('value', (snapshot) => {
            dAll[dId] = snapshot.val()
            resolve()
          }, (err) => {
            console.error(err)
            resolve()
          })
        })
      }

      return dAll
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/db/dashboards.js